import { v4 as uuidv4 } from 'uuid';

export function ProductHighlightWrapper(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductHighlightWrapper',
		componentId: uuidv4(),
		props,
		childrenComponents: childrenComponents.length
			? childrenComponents
			: [
					{
						componentName: 'ProductHighlightText',
						componentId: uuidv4(),
						props: {
							message: 'rs {highlightName}',
							blockClass: 'hl-text',
							link: '/collection/{highlightName}',
						},
						childrenComponents: [],
					},
				],
	};
}
